// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jk-0";
export var buttonContainer = "_jk-3";
export var cancelButton = "_jk-4";
export var headerSection = "_jk-6";
export var headerTitle = "_jk-9";
export var messageSideLeft = "_jk-1";
export var messageSideRight = "_jk-2";
export var orderNumberContainer = "_jk-7";
export var orderNumberLabel = "_jk-8";
export var submitButton = "_jk-5";